// extracted by mini-css-extract-plugin
export default {"image-container":"GalleryImage_image-container__ZbiRc","image":"GalleryImage_image__eObUp","title":"GalleryImage_title__8B20Q"};